import { isSameMonth, toDate, parseISO } from 'date-fns';
export const getProgressLevel = (price, maxPrice) => {
    if (maxPrice === 0) {
        return 0;
    }
    return Math.round((price / maxPrice) * 100);
};
export const safeAddDays = (date, days) => {
    const newDate = date instanceof Date ? toDate(date) : parseISO(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};
export const safeStartOfMonth = (date) => {
    const newDate = date instanceof Date ? toDate(date) : parseISO(date);
    newDate.setDate(1);
    return newDate;
};
export const getDaysFromMonth = (initialDate) => {
    let currentDate = safeStartOfMonth(initialDate);
    const dates = [];
    while (isSameMonth(initialDate, currentDate)) {
        dates.push(currentDate);
        currentDate = safeAddDays(currentDate, 1);
    }
    return dates;
};
export const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
export const buildMonthsMap = (prices) => {
    var _a;
    const months = {};
    for (const dateISO in prices) {
        if (!hasOwn(prices, dateISO)) {
            continue;
        }
        const monthISO = safeStartOfMonth(dateISO).toISOString();
        const price = (_a = prices[dateISO]) === null || _a === void 0 ? void 0 : _a.price;
        if (!hasOwn(months, monthISO)) {
            months[monthISO] = { minPrice: null, maxPrice: null };
        }
        if (!price || !Object.keys(price).length) {
            continue;
        }
        const month = months[monthISO];
        const { amount, currency } = price;
        if (!month.minPrice || amount < month.minPrice.amount) {
            month.minPrice = { amount, currency };
        }
        if (!month.maxPrice || amount > month.maxPrice.amount) {
            month.maxPrice = { amount, currency };
        }
    }
    return months;
};
export const getMonthsArray = (monthMap) => {
    const monthsArray = [];
    for (const month in monthMap) {
        if (hasOwn(monthMap, month)) {
            monthsArray.push({
                dateISO: month,
                minPrice: monthMap[month].minPrice
                    ? {
                        amount: monthMap[month].minPrice.amount,
                        currency: monthMap[month].minPrice.currency
                    }
                    : null
            });
        }
    }
    return monthsArray;
};
export const isLongPrice = (money) => {
    var _a, _b;
    return ((_b = (_a = money === null || money === void 0 ? void 0 : money.amount) === null || _a === void 0 ? void 0 : _a.toString(10)) === null || _b === void 0 ? void 0 : _b.length) > 7;
};
export const getSelectedPrice = (prices, openedDate) => {
    var _a, _b;
    const iso = openedDate.toISOString();
    const dateOnly = iso.split('T')[0];
    const key = Object.keys(prices).find(key => key.startsWith(dateOnly));
    return (_b = (_a = prices[iso]) !== null && _a !== void 0 ? _a : prices[dateOnly]) !== null && _b !== void 0 ? _b : (key ? prices[key] : undefined);
};
